const swimmingPoolCleaningService = {
    id: 1,
    title: "Swimming Pool Cleaning",
    image: "/assets/gallery/wimming Pool Cleaning.jpeg",
    image1: "/assets/gallery/wimming Pool Cleaning1.png",
    image2: "/assets/gallery/wimming Pool Cleaning3.jpeg",
    image3: "/assets/gallery/Swimming Pool Cleaning4.jpg",
    shortDescription: "Keep your pool sparkling clean and safe for use.",
    description:
      "Our Swimming Pool Cleaning service ensures your pool remains clean, hygienic, and ready for use at all times. We specialize in removing debris, algae, and other contaminants to maintain crystal-clear water and a well-functioning pool system.",
    description1:
      "We perform a comprehensive cleaning process, including skimming, vacuuming, brushing, and chemical balancing. Our team uses advanced equipment and eco-friendly cleaning agents to ensure thorough sanitation without harming the environment.",
    description2:
      "In addition to cleaning, we inspect your pool equipment, such as filters and pumps, to ensure they are functioning optimally. Whether it’s routine maintenance or a one-time deep clean, our expert team guarantees a safe and inviting pool for your enjoyment.",
    benefits: [
      "Crystal-clear and hygienic pool water.",
      "Removal of debris, algae, and contaminants.",
      "Eco-friendly cleaning agents used.",
      "Proper chemical balance for safety.",
      "Inspection of pool equipment included.",
      "Professional and reliable service.",
    ],
  };

export default swimmingPoolCleaningService;